// imports
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { IMAGE } from '../../assets';
import InfoTooltip from '../tooltip/info';
import { LINKS, ROUTES } from '../../constants';
import { STRING_UTILS } from '../../common/utils';
import { selectConfig } from '../../repositories/store/slices';

// interfaces / types / consts
interface Props {
  id: string;
  amount: number;
  disabled?: boolean;
}

// exports
export default function ItemHeader(props: Props): JSX.Element {
  const { id, amount, disabled } = props;
  // hooks configuration
  const navigate = useNavigate();
  const { state, pathname } = useLocation();
  const { items } = useSelector(selectConfig);
  const [item, setItem] = useState({ name: '', description: '' });
  // private methods
  const handleItemClick = (): void => navigate(ROUTES.BACKPACK, {
    state: {
      id, pinId: state?.pinId, quest: state?.quest, prevPage: pathname
    }
  });

  useEffect(() => {
    const backpackItem = items[id];
    setItem({ name: backpackItem?.name, description: backpackItem?.info });
  }, [id, items]);

  // render
  return (
    <div className="item-header">
      <div id={id} className="item-container">
        <img
          alt="currency"
          className="currency-icon"
          src={`${LINKS.BACKPACK_BUCKET_URL}/${id}.png`}
          onError={({ currentTarget }) => { currentTarget.src = IMAGE.ITEM_PLACEHOLDER; }}
        />
        <button
          type="button"
          disabled={disabled}
          className="currency-bg"
          onClick={pathname !== ROUTES.BACKPACK ? handleItemClick : undefined}
        >
          {STRING_UTILS.formatNumber(amount || 0)}
        </button>
      </div>
      <InfoTooltip
        place="bottom"
        title={item.name}
        openOnClick={false}
        anchorSelect={`#${id}`}
        description={item.description}
      />
    </div>
  );
}

// default props
ItemHeader.defaultProps = { disabled: false };
